import { render, staticRenderFns } from "./DefaultSidebar.vue?vue&type=template&id=7de63470&scoped=true&"
import script from "./DefaultSidebar.vue?vue&type=script&lang=js&"
export * from "./DefaultSidebar.vue?vue&type=script&lang=js&"
import style0 from "./DefaultSidebar.vue?vue&type=style&index=0&id=7de63470&prod&lang=less&scoped=true&"
import style1 from "./DefaultSidebar.vue?vue&type=style&index=1&id=7de63470&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7de63470",
  null
  
)

export default component.exports